import { render, staticRenderFns } from "./PopupBeforePositionPro.vue?vue&type=template&id=20b8b581&scoped=true&"
import script from "./PopupBeforePositionPro.vue?vue&type=script&lang=js&"
export * from "./PopupBeforePositionPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8b581",
  null
  
)

export default component.exports